import { render, staticRenderFns } from "./completedHomeworkList.vue?vue&type=template&id=59a399e0&scoped=true"
import script from "./completedHomeworkList.vue?vue&type=script&lang=js"
export * from "./completedHomeworkList.vue?vue&type=script&lang=js"
import style0 from "./completedHomeworkList.vue?vue&type=style&index=0&id=59a399e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a399e0",
  null
  
)

export default component.exports